(function($) {
  if ($('.hv-browse').length) {
    var debug = true;
    var listings = {
      pageName: $('.listing-tabs').data('destname'),
      isDetail: $('.listing-tabs').data('detail'),
      listingType: $('.tax-destinations').length ? 'destinations' : 
                    $('.tax-themes').length ? 'themes' :
                    $('.tax-collections').length ? 'collections' : 'unknown',
      defaultStayType: $('.listing-tabs__tab.normal').eq(0).data('default'),
      currentStayType: 'All',
      currentTaxFilter: false,
      onFeatured: $('.listing-tabs').data('destname') == 'Featured Villas',
      clearBtnVillas: $('#js-clear-villa-filters'),
      clearBtnTours: $('#js-clear-tour-filters'),
      mode: 'Villas',
      oldImage: $('.hv-hero__img').data('bg') === undefined ? $('.hv-hero__img').css('background-image').slice(4,-1).replace(/['"]/g, "") : $('.hv-hero__img').data('bg'),
      load: false,
      onLoad: false,
      mobile: ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) ? true : false,
      // the main villa filter function
      filter: function() {
        console.log('-- running filters...');    
        // function variables
        var villas         = $('.hv-villa'); // all villas
        var taxFilter      = listings.currentTaxFilter; // current destination/themes filter
        var stayFilter     = listings.currentStayType == "All" ? false : listings.currentStayType;
        var villaOpts      = $('#js-villa-options').find('.option__value');
        var optionCount    = $('#meta-filter .hv-filter').find('[type="checkbox"]:checked');
        var stepperCount   = $('#meta-filter .option__stepper__btn--down').not('is-disabled');
        var collectionOpts = [];
        var collections    = $('#js-collection-options').find('[type="checkbox"]:checked');
        // collect all of the villa options from first section
        var filterOptions  = listings.extractOptions(villaOpts);
        // collect all of the selected collections
        collections.each(function() {
          collectionOpts.push($(this).attr('name'));
        })
        // get total number of filters selected
        var filterCount    = filterOptions.length + collectionOpts.length;        

        // show all villas by default
        villas.show();

        // exit the function if there are no filters and we are not on default page load
        if (filterCount == 0 && !listings.loading && !listings.onLoad && !taxFilter && !stayFilter) { listings.clearVillaFilter(); return false; }

        // prepare comparison variables
        if (taxFilter) {
          if (debug) { console.log('-- running tax filter'); }
          var taxCompare = taxFilter.toLowerCase();
          // update destination/theme button text to baseTax
          var baseTax = taxFilter.split('/');
          baseTax     = baseTax[baseTax.length-1].trim();          
          $('#js-tax-toggle > span').text(baseTax);          
        } else {
          if (debug) { console.log('-- NOT running tax filter'); }
        }
        if (stayFilter) {
          if (debug) { console.log('-- running stay type filter'); }
        } else {
          if (debug) { console.log('-- NOT running stay type filter'); }
        }
        if (filterCount != 0) {
          if (debug) { console.log('-- running picker box filter'); }
          // update filter button text with number of chosen options
          if ($('.filterText').length) {
            $('.filterText').text('('+filterCount+')');
          } else {
            var filterText = $('<span />').addClass('filterText').text('('+filterCount+')').appendTo($('#js-meta-toggle > span'));
          }
        } else {
          if (debug) { console.log('-- NOT running picker box filter'); }
        }
        villas.each(function(){
          var showMe = true;          
          var dontCount = false;
          // tax filter comparison
          if (taxFilter) {          
            var thisCompare = listings.listingType == "destinations" ? $(this).attr('data-themes') : $(this).attr('data-destination').toLowerCase();
            if (thisCompare) {
              console.log(thisCompare, taxCompare);
              if (!thisCompare.includes(taxCompare)) {
                showMe = false;
                dontCount = true;
              } 
            }
          }

          // stay filter comparison
          if (stayFilter) {
            var thisType = $(this).data('stay');
            if (listings.currentStayType != thisType) {
              showMe = false;
            } 
          }

          // picker box comparison
          if (filterCount != 0) {
            var villa = $(this);
            var sortScore = 0;

            // for each villa option, check object value against data-attribute
            $.each(filterOptions, function() {
              var name = this.name;
              var value = this.value;          

              // for boolean options, -- a/c, kid friendly
              if (typeof(villa.data(name)) == 'string') {
                if (value != villa.data(name)) {
                  showMe = false;   
                  dontCount = true;          
                }
              } else { // for numeric options -- beds, baths, group size
                var villaValue  = parseFloat(villa.data(name));
                var value       = parseFloat(value);
                if (name=="maxs") {
                  // check if between num and num+2 for Max Occupancy
                  if (villaValue < value || villaValue > value+2) {
                    showMe = false;
                    dontCount = true;
                  } else {
                    sortScore += 2 - (villaValue - value);
                  }
                }
                if (name=="beds") {
                  // check if between num and num+1 for Bedrooms
                  if (villaValue < value || villaValue > value+1) {
                    showMe = false;
                    dontCount = true;
                  } else {
                    sortScore += 1 - (villaValue - value);
                  }
                }
                if (name=="baths") {
                  // check if between num-1 and num+1 for Bathrooms
                  if (villaValue < value-1 || villaValue > value+1) {
                    showMe = false;
                    dontCount = true;
                  } else {
                    sortScore += 1 - Math.abs(villaValue - value);
                  }
                }
              }

              // console.log(name,value,villaValue,sortScore);
            });

            villa.attr('sort-score',sortScore);

            // check if the villa collection does not match selected collection
            if (collectionOpts.length) {
              var hideBecauseOfCollection = true;
              $.each(collectionOpts, function() {
                if (villa.data('collection') == this) {
                  hideBecauseOfCollection = false;           
                }
              });
              if (hideBecauseOfCollection) {
                showMe = false;  
                dontCount = true;      
              }
            }
          }

          if (!showMe) {
            $(this).hide();
          }
          if (dontCount) {
            $(this).addClass('no-count');
          } else {
            $(this).removeClass('no-count');
          }
        });

        // sort visible villas
        villas.filter(':visible').detach().sort(function(a,b){
          var valA = parseInt($(a).attr('sort-score'));
          var valB = parseInt($(b).attr('sort-score'));
          // console.log(valA,valB,valA < valB ? 1 : -1);

          return valA < valB ? 1 : -1;
        }).prependTo('.hv-villa-wrap');

        // deal with new layouts
        listings.fixVillas();

        // show the clear button, hide the filter dialog, and remove the menu-open class on villa wrap
        // show the clear button only if there are filters beyond stay type
        console.log('clear all check',filterCount, taxFilter);
        if (filterCount != 0 || taxFilter) { listings.clearBtnVillas.show(); }        
        $('.hv-filter').hide('fast');
        $('.hv-villa-wrap').removeClass('menu-open');

        // deal with no results
        $('.hv-browse__listing > h3').remove();
        if (!$('.hv-villa').filter(':visible').length) {
          $('.hv-browse__listing').append('<h3 style="max-width: 1400px;width: 95%;margin: -70px auto 60px;">No results found</h3>');
        }

        // update counts
        listings.updateCounts();

        // update title
        if (!listings.onFeatured) {
          if (listings.currentStayType != "All") {
            $('.hv-browse__header > h2').text(listings.currentStayType+' in '+listings.pageName);
          } else {
            if (listings.defaultStayType == "All") {
              $('.hv-browse__header > h2').text('Luxury Properties in '+listings.pageName);
            } else {
              $('.hv-browse__header > h2').text(listings.defaultStayType+' in '+listings.pageName);
            }
          }
        } else {
          $('.hv-browse__header > h2').text('Featured Villas');
        }

        // push new URL if not loading
        if (!listings.onLoad) {
          var url = [location.protocol, '//', location.host, location.pathname].join('');
          var filterString="?";
          // tax choice part of query
          var filterText = $('#js-tax-toggle > span').text();
          if (filterText != "Themes" && filterText != "Destinations") {
            filterString += "subcat="+encodeURIComponent(filterText)+'&';
          }
          // stay type part of query
          if (listings.currentStayType != "All") {
            filterString += "stay="+listings.currentStayType+'&';
          }
          // picker box part of query
          $.each(filterOptions,function(index,item) {
            filterString += item.name+'='+item.value+'&';
          });
          if (collectionOpts.length) {
            filterString += "collections=";
            $.each(collectionOpts,function(index,item) {
              filterString += item+',';   
            });
          } 
          
          // console.log('pushing',url+filterString);
          history.pushState(null, null, url+filterString);        
        } else {
          listings.onLoad = false;
        }
      },
      // the main tours filter function
      filterTours: function() {
        console.log('-- running tour filters --');

        // function variables
        var tours          = $('.listing'); // all tours
        var taxFilter      = listings.currentTaxFilter; // current destination/themes filter
        var timeOpts       = $('#js-tour-time-options').find('.option__value');
        var budgetOpts     = $('#js-tour-budget-options').find('.option__value');
        var optionCount    = $('#tours-filter .hv-filter').find('[type="checkbox"]:checked');

        // collect all of the tour options from first and second section
        var timeOptions    = listings.extractOptions(timeOpts);
        var budgetOptions  = listings.extractOptions(budgetOpts);
        // get total number of filters selected
        var filterCount    = timeOptions.length + budgetOptions.length;        

        // show all tours by default
        tours.show();

        // exit the function if there are no filters and we are not on default page load
        if (filterCount == 0 && !listings.loading && !listings.onLoad && !taxFilter) { listings.clearTourFilter(); return false; }

        // prepare comparison variables
        if (taxFilter) {
          if (debug) { console.log('-- running tax filter'); }
          var taxCompare = taxFilter.toLowerCase();
          // update destination/theme button text to baseTax
          var baseTax = taxFilter.split('/');
          baseTax     = baseTax[baseTax.length-1].trim();          
          $('#js-tax-toggle > span').text(baseTax);          
        } else {
          if (debug) { console.log('-- NOT running tax filter'); }
        }
        if (filterCount != 0) {
          if (debug) { console.log('-- running time or budget filters'); }
          // update filter button text with number of chosen options
          if ($('.filterText').length) {
            $('.filterText').text('('+filterCount+')');
          } else {
            var filterText = $('<span />').addClass('filterText').text('('+filterCount+')').appendTo($('#tours-filter-toggle > span'));
          }
        } else {
          if (debug) { console.log('-- NOT running time or budget filters'); }
        }

        tours.each(function(index, tour){
          var showMe = true;          
          var dontCount = false;
          // tax filter comparison
          if (taxFilter) {          
            var thisCompare = listings.listingType == "destinations" ? $(this).attr('data-themes') : $(this).attr('data-destination').toLowerCase();
            if (thisCompare) {
              console.log(thisCompare, taxCompare);
              if (!thisCompare.includes(taxCompare)) {
                showMe = false;
                dontCount = true;

                console.log('hiding for tax');
              } 
            }
          }

          // time comparison
          if (timeOptions.length != 0) {
            var hasTime = false;
            var tourTimes = $(tour).data('times');
            if (tourTimes) {
              $.each(timeOptions, function(){
                var name = this.name;
                var value = this.value;

                console.log(tourTimes.toLowerCase(),name,tourTimes.toLowerCase().includes(name));
                if (tourTimes.toLowerCase().includes(name)) {
                  hasTime = true;
                }
              });
            }
            if (!hasTime) {
              showMe = false;
              dontCount = true;

              console.log('hiding for time');
            }
          }

          // budget comparison
          if (budgetOptions.length != 0) {
            var hasBudget = false;
            var tourBudget = $(tour).data('price');
            if (tourBudget) {
              $.each(budgetOptions, function(){
                var name = this.name;
                var value = this.value;

                console.log(tourBudget,name);

                if (name == 'under $2,000' && tourBudget < 2000) {
                  hasBudget = true;
                }

                if (name == '$2,000 - $2,999' && tourBudget >= 2000 && tourBudget < 3000) {
                  hasBudget = true;
                }

                if (name == '$3,000 - $4,999' && tourBudget >= 3000 && tourBudget < 5000) {
                  hasBudget = true;
                }

                if (name == '$5,000 - $9,999' && tourBudget >= 5000 && tourBudget < 10000) {
                  hasBudget = true;
                }

                if (name == '$10,000+' && tourBudget >= 10000) {
                  hasBudget = true;
                }
              });
            }
            if (!hasBudget) {
              showMe = false;
              dontCount = true;

              console.log('hiding for budget');
            }
          }

          console.log('hiding: ', !showMe);
          if (!showMe) {
            $(this).hide();
          }
          if (dontCount) {
            $(this).addClass('no-count');
          } else {
            $(this).removeClass('no-count');
          }
        });

        // deal with new layouts
        listings.fixVillas();

        // show the clear button, hide the filter dialog, and remove the menu-open class on villa wrap
        listings.clearBtnTours.show();
        $('.hv-filter').hide('fast');
        $('.hv-villa-wrap').removeClass('menu-open');

        // deal with no results
        $('.hv-browse__listing > h3').remove();
        if (!$('.listing').filter(':visible').length) {
          $('.hv-browse__listing').append('<h3 style="max-width: 1400px;width: 95%;margin: -70px auto 60px;">No results found</h3>');
        }

        // update counts
        listings.updateCounts();

        // push new URL if not loading
        // if (!listings.onLoad) {
        //   var url = [location.protocol, '//', location.host, location.pathname].join('');
        //   var filterString="?";
        //   // tax choice part of query
        //   var filterText = $('#js-tax-toggle > span').text();
        //   if (filterText != "Themes" && filterText != "Destinations") {
        //     filterString += "subcat="+encodeURIComponent(filterText)+'&';
        //   }
        //   // stay type part of query
        //   if (listings.currentStayType != "All") {
        //     filterString += "stay="+listings.currentStayType+'&';
        //   }
        //   // picker box part of query
        //   $.each(filterOptions,function(index,item) {
        //     filterString += item.name+'='+item.value+'&';
        //   });
        //   if (collectionOpts.length) {
        //     filterString += "collections=";
        //     $.each(collectionOpts,function(index,item) {
        //       filterString += item+',';  
        //     });
        //   }
          
        //   // console.log('pushing',url+filterString);
        //   history.pushState(null, null, url+filterString);        
        // } else {
        //   listings.onLoad = false;
        // }
      },
      // clear filters (picker box, destinations/experiences, and stay types)
      clearVillaFilter: function() {
        console.log('++ Clearing all villa filters');
        var villas = $('.hv-villa');
        var steppers = $('.stepper');
        var checkboxes = $('#meta-filter, #tax-filter').find('[type="checkbox"]');
        var filterBtn = $('#js-meta-toggle');

        // reset all picker box steppers
        steppers.each(function() {
          var initialVal = $(this).data('min');
          var value = $(this).find('.option__stepper__value').find('input');
          $(this).find('.option__stepper__btn--down').addClass('is-disabled');

          value.val('');
        });
        // uncheck all picker box checkboxes
        checkboxes.prop('checked', false);
        // hide picker box
        $('.hv-filter').hide(); 
        // de-activate filter button
        filterBtn.removeClass('is-active');
        // remove menu-open fade class on villas parent
        villas.parent().removeClass('menu-open');
        // remove option count from filter button
        filterBtn.find('.filterText').remove();
        // show all villas
        villas.show().removeClass('dont-sort');
        // make all villas countable
        villas.removeClass('no-count');
        // remove no results text
        $('.hv-browse__listing > h3').remove();
        // return stay type to normal (or explore if not on detail page)
        // if (listings.isDetail) {
          $('.listing-tabs__section:not(.listing-tabs__section--tours)').each(function(){
            $(this).find('.listing-tabs__tab.normal').removeClass('active').eq(0).addClass('active');
          });
          var defaultTitle = $('.listing-tabs__tab').eq(0).data('default');
          if (defaultTitle == 'All') { defaultTitle = 'Luxury Properties'; }
          if (!listings.onFeatured) {
            $('.hv-browse__header > h2').text(defaultTitle+' in '+listings.pageName);
          } else {
            $('.hv-browse__header > h2').text('Featured Villas');
          }
        // } else {
        //   $('.dest-box').hide().filter('.dest-detail__destination').show();
        //   $('.listing-tabs__section').each(function(){
        //     $(this).find('.listing-tabs__tab').removeClass('active').filter('.js-explore').addClass('active');
        //     $('.hv-browse__header > h2').text('Locations in '+listings.pageName);
        //   });
        // }
        // clear dest/theme filter
        listings.currentTaxFilter = false;
        // update splash graphic to old image
        $('.hv-hero__img').css('background-image','url('+listings.oldImage+')');
        // return button to previous text
        if (listings.listingType == "destinations") {
          $('#js-tax-toggle > span').text('Themes');
        } else {
          $('#js-tax-toggle > span').text('Destinations');
        }
        listings.fixVillas();
        // update counts
        listings.updateCounts();
        // clear URL
        listings.clearURL();
      },
      // clear tour filters
      clearTourFilter: function() {
        console.log('++ Clearing all tour filters');
        var tours = $('.listing');
        var checkboxes = $('#tours-filter, #tax-filter').find('[type="checkbox"]');
        var filterBtn = $('#tours-filter-toggle');

        // uncheck all picker box checkboxes
        checkboxes.prop('checked', false);
        // hide picker box
        $('.hv-filter').hide(); 
        // de-activate filter button
        filterBtn.removeClass('is-active');
        // remove menu-open fade class on tours parent
        tours.parent().removeClass('menu-open');
        // remove option count from filter button
        filterBtn.find('.filterText').remove();
        // show all tours
        tours.show().removeClass('dont-sort');; 
        // make all tours countable
        tours.removeClass('no-count');
        // remove no results text
        $('.hv-browse__listing > h3').remove();
        // clear dest/theme filter
        listings.currentTaxFilter = false;
        // update splash graphic to old image
        $('.hv-hero__img').css('background-image','url('+listings.oldImage+')');
        // return button to previous text
        if (listings.listingType == "destinations") {
          $('#js-tax-toggle > span').text('Themes');
        } else {
          $('#js-tax-toggle > span').text('Destinations');
        }
        listings.fixVillas();
        // update counts
        listings.updateCounts();
        // clear URL
        listings.clearURL();
      },
      // clear the URL filter state
      clearURL: function() {
        // hide clear buttons
        listings.clearBtnVillas.hide();
        listings.clearBtnTours.hide();
        // push clear URL
        var url = [location.protocol, '//', location.host, location.pathname].join('');
        history.pushState(null, null, url);
      },
      // updates various unit counts across the filters
      updateCounts: function() {
        // grab the villas or tours depending on mode
        var items = listings.mode == 'Villas' ? $('.hv-villa:not(.no-count)') : $('.listing:not(.no-count)');
        // initialize count variables
        var listingNums = []; // init stay type numbers        
        var tabs = listings.mode == 'Villas' ? $('.listing-tabs__tab.normal') : $('.listing-tabs__tab.tours');
        tabs.each(function(){
          var type = $(this).data('type');
          listingNums[type] = 0;
        });
        var taxNums = []; // init tax type numbers
        $('.tax-option').each(function(){
          var slug = $(this).data('slug');
          taxNums[slug] = 0;
        });
        // go through the items and grab various counts
        items.each(function(){
          var type   = $(this).data('stay');          
          listingNums[type]++;
          if ($(this).is(':visible')) {
            var slugs  = listings.listingType == 'destinations' ? $(this).data('themes') : $(this).data('destination');
            if (slugs) {
              $.each(slugs.split(", "),function(index, value){
                taxNums[value]++;
              });
            }
          }
        });
        // update the counts
        console.log(listingNums);
        tabs.each(function(){
          var type = $(this).data('type');
          if (type=="All") {
            $(this).find('b').text('('+items.length+')');
          } else {
            $(this).find('b').text('('+listingNums[type]+')');
          }
        });
        $('.tax-option').each(function(){
          var slug = $(this).data('slug');
          $(this).find('b').text('('+taxNums[slug]+')');
        });
      },
      // toggle the stay type dropdown on mobile
      toggleListingsDropdown: function() {
        $('.listing-tabs__dropdown__list').slideToggle().parent().toggleClass('open');
      },
      // toggles the visibility of the meta filter
      toggleMetaFilter: function () {
        if (!$('#meta-filter:visible').length) {
          $('#meta-filter').slideDown('fast');
          $('.hv-villa-wrap').addClass('menu-open');
          $('#js-meta-toggle').addClass('is-active');
        } else {
          $('#meta-filter').slideUp('fast');
          $('.hv-villa-wrap').removeClass('menu-open');
          $('#js-meta-toggle').removeClass('is-active');
        }
        // hide tax and tour filter
        $('#tax-filter, #tours-filter').slideUp();
        $('#js-tax-toggle').removeClass('is-active');
        $('#tours-filter-toggle').removeClass('is-active');
      },
      // toggles the visibility of the tour filter
      toggleTourFilter: function () {
        if (!$('#tours-filter:visible').length) {
          $('#tours-filter').slideDown('fast');
          $('.hv-villa-wrap').addClass('menu-open');
          $('#tours-filter-toggle').addClass('is-active');
        } else {
          $('#tours-filter').slideUp('fast');
          $('.hv-villa-wrap').removeClass('menu-open');
          $('#tours-filter-toggle').removeClass('is-active');
        }
        // hide tax and villa filter
        $('#tax-filter, #meta-filter').slideUp();
        $('#js-tax-toggle').removeClass('is-active');
        $('#meta-filter').removeClass('is-active');
      },
      // make a choice in the tax filter
      taxChoice: function(choice) {
        var newModalFilter = choice.data('slug');
        var newImage = choice.data('bg');
        // console.log(newModalFilter, newImage);
        // update splash graphic
        $('.hv-hero__img').css('background-image','url('+newImage+')');         
        // close tax filter
        listings.toggleTaxFilter();
        // run filter and fade out modal
        listings.loading = true;
        listings.currentTaxFilter = newModalFilter;
        listings.mode == 'Villas' ? listings.filter() : listings.filterTours();
        // scroll to top of page if not on mobile
        if (!listings.mobile) {
          $('html, body').animate({
              scrollTop: 0
            }, 800);
        }
      },
      // clicking one of the picker box stepper btns
      clickFilterSteppers: function(stepperBtn) {
        var min    = stepperBtn.closest('.stepper').data('min');
        var max    = stepperBtn.closest('.stepper').data('max');
        var delta  = stepperBtn.hasClass('option__stepper__btn--up') ? 1 : -1;
        var input   = stepperBtn.siblings('.option__stepper__value').find('input'); 
        if (input.val()=="") {      
          var newVal = min;
        } else {
          var value  = parseInt(input.val());
          var newVal = value + delta;
        }    
        if (min === newVal)
          input.parent().siblings('.option__stepper__btn--down').addClass('is-disabled');

        if (max === newVal)
          input.parent().siblings('.option__stepper__btn--up').addClass('is-disabled');

        if (min < newVal && newVal < max)
          input.parent().siblings('.option__stepper__btn').removeClass('is-disabled');

        input.val(newVal);

        this.updateCollectionNums();
      },
      // directly editing one of the picker box stepper values
      editStepperValues: function(stepperBtn) {
        var min    = $(this).closest('.stepper').data('min');
        var max    = $(this).closest('.stepper').data('max');
        var val    = $(this).val();
        if (val != "") {
          val = parseInt(val);
          if (isNaN(val)) { alert('Please provide a valid number.'); $(this).val(''); return; }
          if (min > val || val > max) {
            var header = $('.hv-browse__header h2').text().toLowerCase();
            alert('Please pick a number between '+min+' and '+max+' as this is the available range for the '+header+'.'); $(this).val(''); return;
          }
          $(this).val(val);
          var input   = $(this);
          if (min === val)
            input.parent().siblings('.option__stepper__btn--down').addClass('is-disabled');
            input.parent().siblings('.option__stepper__btn--up').removeClass('is-disabled');
          if (max === val)
            input.parent().siblings('.option__stepper__btn--up').addClass('is-disabled');
            input.parent().siblings('.option__stepper__btn--down').removeClass('is-disabled');
          if (min < val && val < max)
            input.parent().siblings('.option__stepper__btn').removeClass('is-disabled');
        }

        this.updateCollectionNums();
      },
      // update collection counts for current filter set
      updateCollectionNums: function() {
        var villas         = $('.hv-villa:not(.dont-sort)');
        var filterVillas   = [];
        var villaOpts      = $('#js-villa-options').find('.option__value');
        var collectionOpts = [];
        var collections    = $('#js-collection-options').find('[type="checkbox"]');
        var collectionNums = [0,0,0,0,0,0,0,0];
        // collect all of the villa options from first section
        var filterOptions  = listings.extractOptions(villaOpts);
        // collect all of the selected collections
        collections.each(function() {
          collectionOpts.push($(this).attr('name'));
        });    
        // for each villa, test it against the set filters, if it fails the test we don't count the 
        villas.each(function(){
          var villa = $(this);
          var include = true;  

          // for each villa option, check object value against data-attribute
          $.each(filterOptions, function() {
            var name = this.name;
            var value = this.value;             

            // for boolean options, -- a/c, kid friendly
            if (typeof(villa.data(name)) == 'string') {
              if (value != villa.data(name)) {
                include = false;            
              }
            } else { // for numeric options -- beds, baths, group size
              var villaValue  = parseFloat(villa.data(name));
              var value       = parseFloat(value);
              if (name=="maxs") {
                // check if between num and num+2 for Max Occupancy
                if (villaValue < value || villaValue > value+2) {
                  include = false;
                }
              }
              if (name=="beds") {
                // check if between num and num+1 for Bedrooms
                if (villaValue < value || villaValue > value+1) {
                  include = false;
                }
              }
              if (name=="baths") {
                // check if between num-1 and num+1 for Bathrooms
                if (villaValue < value-1 || villaValue > value+1) {
                  include = false;
                }
              }
            }
          });

          if (include) {
            filterVillas.push(villa);
          }
        });

        $.each(filterVillas,function(index,item){
          $.each(collectionOpts, function(index2,item2) {
            if (item.data('collection') == this) {
              collectionNums[index2]++;          
            }
          });
        });

        $('#js-collection-options .option').each(function(index){
          var newNum = collectionNums[index];
          $(this).find('label span span').text('('+newNum+')');
          if (newNum == 0) {
            $(this).addClass('disabled');
            $(this).find('[type="checkbox"]').prop('checked',false);
          } else {
            $(this).removeClass('disabled');
          }
        });
      },
      // show or hide the taxonomy filter
      toggleTaxFilter: function() { 
        // console.log('toggling tax filter');       
        if (!$('#tax-filter:visible').length) {
          $('#tax-filter').slideDown('fast');
          $('.hv-villa-wrap').addClass('menu-open');
          $('#js-tax-toggle').addClass('is-active');
        } else {
          $('#tax-filter').slideUp('fast');
          $('.hv-villa-wrap').removeClass('menu-open');
          $('#js-tax-toggle').removeClass('is-active');
        }
        // hide meta and tours filter
        $('#meta-filter, #tours-filter').slideUp();
        $('#js-meta-toggle, #tours-filter-toggle').removeClass('is-active');
      },
      // loops over jquery object and extracts element name or checkbox value
      extractOptions: function(el) {
        var options = [];
        $(el).each(function(){
          var option = {};
          var key = $(this).attr('id');
          option['name'] = $(this).attr('id');
          option['value'] = false;

          if ($(this).attr('type')=="text") {
            option['value'] = $(this).val();
          } else {
            option['value'] = $(this).is(':checked') ? "Yes" : "";
          }

          if (option['value'] != "") {
            options.push(option);
          }
        });
        return options;
      }, 
      // fixes villa layout after showing/hiding villas
      fixVillas: function() {
        setTimeout(function(){
          // console.log('fixing things...');
          $(window).trigger('blockHeight');
          $(window).trigger('resize');
          Foundation.reflow(document, 'equalizer');
          Foundation.reInit('equalizer');          
        },500);
      },
      // startup listing function to fire on every page load and pop state
      startup: function() {
        // preselected taxonomy load       
        var subcatOnLoad  = getParameterByName('subcat');
        if (subcatOnLoad) {
          $('.tax-option').each(function(){
            var subcat = $(this).find('> span').text();
            if (subcat.includes(subcatOnLoad)) { 
              listings.onLoad = true;         
              // console.log('triggering subcat load') ;
              $(this).trigger('click');
            }
          });
        } else {
          listings.currentTaxFilter = false;
          if (listings.listingType == "destinations") {
            $('#js-tax-toggle > span').text('Themes');
          } else {
            $('#js-tax-toggle > span').text('Destinations');
          }       
          $('.hv-hero__img').css('background-image','url('+listings.oldImage+')');  
        }

        // stay type load
        var stayTypeOnLoad = getParameterByName('stay');
        if (stayTypeOnLoad) {
          $('.dest-box').hide().filter('.dest-detail__villas').show();
          $('.listing-tabs__tab').removeClass('active').filter('[data-type="'+stayTypeOnLoad+'"]').addClass('active');
          $('.hv-browse__header > h2').text(stayTypeOnLoad+' in '+listings.pageName);
          listings.currentStayType = stayTypeOnLoad;
          $('.listing-tabs__dropdown__current').text(stayTypeOnLoad);
        } else {
          // return stay type to normal (or explore if not on detail page)
          if (listings.isDetail) {
            $('.listing-tabs__section').each(function(){
              $(this).find('.listing-tabs__tab.normal').removeClass('active').eq(0).addClass('active');
            });
            var defaultTitle = $('.listing-tabs__tab').eq(0).data('default');
            if (defaultTitle == 'All') { defaultTitle = 'Luxury Properties'; }
            if (!listings.onFeatured) {
              $('.hv-browse__header > h2').text(defaultTitle+' in '+listings.pageName);
            } else {
              $('.hv-browse__header > h2').text('Featured Villas');
            }
          } else {
            $('.dest-box').hide().filter('.dest-detail__destination').show();
            $('.listing-tabs__section').each(function(){
              $(this).find('.listing-tabs__tab').removeClass('active').filter('.js-explore').addClass('active');
              $('.listing-tabs__section--noBorder').find('.listing-tabs__tab').addClass('disabled');
              $('.hv-browse__header > h2').text('Locations in '+listings.pageName);
            });
          }
          
          listings.currentStayType = 'All';
        }

        // picker box load
        var maxsOnLoad = getParameterByName('maxs');
        var bedsOnLoad = getParameterByName('beds');
        var bathsOnLoad = getParameterByName('baths');
        var kidsOnLoad = getParameterByName('kids');
        var acOnLoad = getParameterByName('ac');
        var collectionsOnLoad = getParameterByName('collections');

        if (maxsOnLoad) { $('#maxs').val(maxsOnLoad); } else { $('#maxs').val(''); }
        if (bedsOnLoad) { $('#beds').val(bedsOnLoad); } else { $('#beds').val(''); }
        if (bathsOnLoad) { $('#baths').val(bathsOnLoad); } else { $('#baths').val(''); }
        if (kidsOnLoad=="Yes") { $('#kids').prop('checked',true); } else { $('#kids').prop('checked',false); }
        if (acOnLoad=="Yes") { $('#ac').prop('checked',true); } else { $('#ac').prop('checked',false); }
        $('#js-collection-options input').prop('checked',false);
        if (collectionsOnLoad) {
          $.each(collectionsOnLoad.split(','),function(index,item){
            $('#js-collection-options input').each(function(){
              if ($(this).attr('name')==item) {
                $(this).prop('checked',true);
              }
            });
          });
        }

        // if there's no filters, restore everything/make everything normal
        if (!subcatOnLoad && !maxsOnLoad && !bedsOnLoad && !bathsOnLoad && ! kidsOnLoad && !acOnLoad && !stayTypeOnLoad) {    
          // console.log('regular startup');    
          // show all villas
          $('.hv-villa').show();          
          // return picker box button to previous text
          $('.filterText').remove();
          // fix villas
          listings.fixVillas();
          // remove clear button
          listings.clearBtnVillas.hide();
        } else { 
          // console.log('startup with query: ',subcatOnLoad,stayTypeOnLoad);
          listings.onLoad = true; 
          listings.filter();
        }
      },
    };

    // create all listing triggers
    listingTriggers();

    // run listing startup functions
    listingStartup();
  }

  // all of the hooks necessary to run the listing pages
  function listingTriggers() {
    // Clear Filters when button is clicked
    listings.clearBtnVillas.on('click', listings.clearVillaFilter);
    listings.clearBtnTours.on('click', listings.clearTourFilter);

    // Toggle Meta Filter when button is clicked
    $('#js-meta-toggle').on('click', function(e){ if ($(e.target).prop('id') == 'js-meta-toggle') { listings.toggleMetaFilter(); } });
    $('#js-meta-toggle > span').on('click', function(){ listings.toggleMetaFilter(); });

     // Toggle Tax Filter when button is clicked
    $('#js-tax-toggle').on('click', function(e){ if ($(e.target).prop('id') == 'js-tax-toggle') { listings.toggleTaxFilter(); } });
    $('#js-tax-toggle > span').on('click', function(){ listings.toggleTaxFilter(); });

    // Toggle Tour Filter when button is clicked
    $('#tours-filter-toggle').on('click', function(e){ if ($(e.target).prop('id') == 'tours-filter-toggle') { listings.toggleTourFilter(); } });
    $('#tours-filter-toggle > span').on('click', function(){ listings.toggleTourFilter(); }); 

    // close Meta, Tax, and Tours Filter when clicking outside of them when open
    $(document).on('click',function(e){
      if ($('.hv-filter:visible').length) {
        var target = $(e.target);
        if (!target.hasClass('.hv-filter') && !target.closest('.hv-filter').length && !target.hasClass('.listing-tabs__tab') && !target.closest('.listing-tabs__tab').length) {
          $('.listing-tabs__section--noBorder .is-active').trigger('click');
        }
      }
    });

    // Filter stepper controls
    $('.option__stepper__btn').on('click', function() { listings.clickFilterSteppers($(this)); });

    // Error check on manual input to filters
    $('.option__stepper input').on('blur',function(){ listings.editStepperValues($(this)); });

    // clicking the apply filter button
    $('#js-apply-villa-filters').on('click',listings.filter);

    // clicking the apply filter button
    $('#js-apply-tour-filters').on('click',listings.filterTours);

    // clicking a tax option
    $('.tax-option').on('click',function() { listings.taxChoice($(this)); });

    // clearing destination/theme filter
    $(document).on('click', '.clearVillaFilter', function(e){ e.preventDefault(); listings.clearVillaFilter(); });

    // clicking listing tabs
    $('.listing-tabs__tab.normal, .js-explore').on('click',function(){
      if (!$(this).hasClass('active')) {
        // activate listings villa mode
        listings.mode = 'Villas';
        // collapse mobile dropdown
        $('.listing-tabs__dropdown__list').slideUp();
        // hide tours
        $('.listing').hide();
        // normal tab vs. explore tab
        if ($(this).hasClass('js-explore')) {
          // update the mobile dropdown current text
          $('.listing-tabs__dropdown__current').text('Explore');
          // make active and sure desktop and mobile options reflect each other
          $('.listing-tabs__tab').removeClass('active').filter('.js-explore').addClass('active');
          // show the explore tab and disable the right-hand filter buttons
          $('.dest-detail__destination').show();
          $('.dest-detail__villas').hide();
          $('.listing-tabs__section--noBorder').find('.listing-tabs__tab').addClass('disabled');
          // clear URL
          listings.clearURL();
        } else {
          var type     = $(this).data('type');
          // hide tours filter and show villa filter
          $('#js-meta-toggle').show();
          $('#tours-filter-toggle').hide();
          // show the villas tab and enable the right-hand filter buttons
          $('.dest-detail__destination').hide();
          $('.dest-detail__villas').show();
          $('.listing-tabs__section--noBorder').find('.listing-tabs__tab').removeClass('disabled');
          // update the mobile dropdown current text
          $('.listing-tabs__dropdown__current').text(type);
          // make active and sure desktop and mobile options reflect each other
          $('.listing-tabs__tab').removeClass('active').filter('[data-type="'+type+'"]').addClass('active');
          // update listing heading          
          if (type == "All") {
            var defaultType = $(this).data('default');
            if (!listings.onFeatured) {
              if (defaultType == "All") {
                $('.hv-browse__header h2').text('Luxury Properties in '+listings.pageName);
              } else {
                $('.hv-browse__header h2').text(defaultType+' in '+listings.pageName);
              }
            } else {
              $('.hv-browse__header h2').text('Featured Villas');
            }
          } else {
            $('.hv-browse__header h2').text(type+' in '+listings.pageName);
          }
          // show the villas that match the stay type
          listings.currentStayType = type;
          listings.filter();
        }
        // run necessary helper fxns
        listings.fixVillas();
        // show correct counts for the mode
        listings.updateCounts();
      }
    });

    // clicking tours tab
    $('.listing-tabs__tab.tours').on('click',function(){
      if (!$(this).hasClass('active')) {
        // activate listings tour mode
        listings.mode = 'Tours';
        // collapse mobile dropdown
        $('.listing-tabs__dropdown__list').slideUp();
        // update the mobile dropdown current text
        $('.listing-tabs__dropdown__current').text('Tours');
        // show the villas tab and enable the right-hand filter buttons
        $('.dest-detail__destination').hide();
        $('.dest-detail__villas').show();
        $('.listing-tabs__section--noBorder').find('.listing-tabs__tab').removeClass('disabled');
        // make this the active tab and also make sure desktop and mobile reflect each other
        $('.listing-tabs__tab').removeClass('active').filter('[data-type="Tours"]').addClass('active');
        // update listing heading
        $('.hv-browse__header h2').text('Tours in '+listings.pageName);
        // hide villa items and show tour items
        const items = $('.hv-villa-wrap > div');
        items.filter('.hv-villa').hide();
        items.filter('.listing').show();
        listings.fixVillas();
        // hide villa filter and show tour filter
        $('#js-meta-toggle').hide();
        $('#tours-filter-toggle').show();
        // clear URL
        listings.clearURL();
        // show correct counts for the mode
        listings.updateCounts();
      }
    });

    // toggling stay type dropdown on mobile
    $('.listing-tabs__dropdown__current').on('click',listings.toggleListingsDropdown);

    // handle internal back/forwards
    window.onpopstate = function(event) {
      // console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
      listings.startup();
    };
  }

  // all of the functions necessary on first load of a listing page
  function listingStartup() {
    listings.startup()
  }

  // helper fxn to get query parameters
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  
})( jQuery );
